<template>
  <div>
    <page-header
      :title="$t('contracts_title')"
      :subtitle="$t('contracts_page_subtitle')"
      icon="mdi-file-document-multiple-outline"
      icon-color="primary"
    >
      <template #actions>
        <primary-button @click="pickRestaurantDialog = true">
          <v-icon class="mr-2">mdi-plus-circle</v-icon>
          {{ $t("new_contract") }}
        </primary-button>
      </template>
    </page-header>

    <v-tabs v-model="tab" color="primary" class="px-4">
      <v-tab>{{ $t("contracts_overview") }}</v-tab>
      <v-tab>{{ $t("pending_price_verification") }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <contracts-overview-tab
          :loading="loadingOverview"
          :contracts="contracts"
          :no-contract-list="noContractList"
          :summary="summary"
          @open-contract="openRestaurantContracts"
          @enter-price="openNewContractFor"
        />
      </v-tab-item>

      <v-tab-item>
        <pending-verification-tab
          :loading="loadingPending"
          :items="pendingItems"
          :groups="pendingGroups"
          @open-item="openWorklistItem"
        />
      </v-tab-item>
    </v-tabs-items>

    <pick-restaurant-dialog
      v-model="pickRestaurantDialog"
      @confirm="onRestaurantPicked"
    />

    <restaurant-contracts-dialog
      v-model="contractsDialog"
      :restaurant="selectedRestaurant"
      @saved="refreshAll"
    />
    <contract-form-dialog
      v-model="newContractDialog"
      :restaurant="selectedRestaurant"
      @saved="refreshAll"
    />
    <restaurant-services-dialog
      v-model="servicesDialog"
      :restaurant="selectedRestaurant"
    />
  </div>
</template>

<script>
import PageHeader from "@/components/global/PageHeader.vue";
import ContractsOverviewTab from "@/components/contracts/ContractsOverviewTab.vue";
import PendingVerificationTab from "@/components/contracts/PendingVerificationTab.vue";
import PickRestaurantDialog from "@/components/contracts/PickRestaurantDialog.vue";
import RestaurantContractsDialog from "@/components/contracts/RestaurantContractsDialog.vue";
import ContractFormDialog from "@/components/contracts/ContractFormDialog.vue";
import RestaurantServicesDialog from "@/components/restaurants/RestaurantServicesDialog.vue";
import hasSnackbar from "@/mixins/hasSnackbar";
import contractsService from "@/services/contracts";
import pricingService from "@/services/pricing";

export default {
  name: "ContractsOverviewPage",
  components: {
    PageHeader,
    ContractsOverviewTab,
    PendingVerificationTab,
    PickRestaurantDialog,
    RestaurantContractsDialog,
    ContractFormDialog,
    RestaurantServicesDialog,
  },
  mixins: [hasSnackbar],
  data() {
    return {
      tab: 0,
      loadingOverview: false,
      loadingPending: false,
      contracts: [],
      noContractList: [],
      summary: {},
      pendingItems: [],
      pendingGroups: {},
      contractsDialog: false,
      newContractDialog: false,
      servicesDialog: false,
      selectedRestaurant: {},
      pickRestaurantDialog: false,
    };
  },
  created() {
    this.refreshAll();
  },
  watch: {
    tab(val) {
      if (val === 1 && !this.pendingItems.length) this.fetchPending();
    },
  },
  methods: {
    refreshAll() {
      this.fetchOverview();
      if (this.tab === 1) this.fetchPending();
    },
    async fetchOverview() {
      this.loadingOverview = true;
      try {
        const { data } = await contractsService.getExpiringContracts();
        this.summary = data.summary || {};
        this.contracts = data.contracts || [];
        this.noContractList = data.bez_ugovora || [];
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_contracts"));
      } finally {
        this.loadingOverview = false;
      }
    },
    async fetchPending() {
      this.loadingPending = true;
      try {
        const { data } = await pricingService.getPendingPriceVerification();
        this.pendingItems = data.items || [];
        this.pendingGroups = data.groups || {};
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_loading_pending_verification"));
      } finally {
        this.loadingPending = false;
      }
    },
    onRestaurantPicked(restaurant) {
      this.selectedRestaurant = restaurant;
      this.newContractDialog = true;
    },
    openRestaurantContracts(contract) {
      this.selectedRestaurant = { id: contract.restaurant_id, name: contract.naziv };
      this.contractsDialog = true;
    },
    openNewContractFor(item) {
      this.selectedRestaurant = { id: item.restaurant_id, name: item.naziv };
      this.newContractDialog = true;
    },
    openWorklistItem(item) {
      this.selectedRestaurant = { id: item.restaurant_id, name: item.naziv };
      if (["UGOVOR ISTEKAO", "UGOVOR USKORO ISTIČE"].includes(item.status)) {
        this.contractsDialog = true;
      } else {
        this.servicesDialog = true;
      }
    },
  },
};
</script>
